import { render, staticRenderFns } from "./NavProfile.vue?vue&type=template&id=34991b9c&scoped=true"
import script from "./NavProfile.vue?vue&type=script&lang=js"
export * from "./NavProfile.vue?vue&type=script&lang=js"
import style0 from "./NavProfile.vue?vue&type=style&index=0&id=34991b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34991b9c",
  null
  
)

export default component.exports